import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { type, space, radius } from '../tokens';

const PaymentMethodCard = ({ method, onChange }) => {
  if (!method) return null;
  const { brand = 'Card', last4 = '••••', expMonth, expYear } = method;
  const expSoon = expMonth && expYear && (() => {
    const now = new Date();
    const exp = new Date(expYear, expMonth - 1, 1);
    const diff = (exp - now) / (1000 * 60 * 60 * 24 * 30);
    return diff < 3;
  })();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: space[3],
      padding: space[4],
      background: 'linear-gradient(135deg, #1a3a5c 0%, #0176d3 100%)',
      color: '#fff',
      borderRadius: radius.md,
      minHeight: 72,
      boxShadow: '0 4px 12px rgba(1,118,211,0.3)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        width: 48, height: 32,
        background: 'rgba(255,255,255,0.2)',
        borderRadius: radius.sm,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icon category="utility" name="shield" size="small" style={{ fill: '#fff' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ ...type.body, fontWeight: 700 }}>
          {brand} ••{last4}
        </div>
        {expMonth && expYear && (
          <div style={{
            ...type.small,
            opacity: 0.85,
            color: expSoon ? '#ffdd88' : '#fff',
            fontWeight: expSoon ? 700 : 400,
          }}>
            Expires {String(expMonth).padStart(2, '0')}/{String(expYear).slice(-2)}
            {expSoon && ' · expires soon'}
          </div>
        )}
      </div>
      {onChange && (
        <button
          onClick={onChange}
          style={{
            padding: `${space[1]}px ${space[3]}px`,
            background: 'rgba(255,255,255,0.2)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.4)',
            borderRadius: radius.sm,
            ...type.small,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Change
        </button>
      )}
    </div>
  );
};

export default PaymentMethodCard;
